import { DataTablePaginate } from '@/common/ui/table/data-table-paginate'
import { DataTableResetFilter } from '@/common/ui/table/data-table-reset-filter'
import { GetReturnLossHistoryResponseData } from '@/modules/promotion/type'
import { columns } from './constants'
import { DataTableSearch } from '@/common/ui/table/data-table-search'
import { DateRangePicker } from '@/common/components/DateRangePicker'
import DateRangeButtons from '@/common/components/DateRangeButtons'
import { parseAsBoolean, useQueryState } from 'nuqs'
import { Label } from '@/common/ui/label'
import { Switch } from '@/common/ui/switch'

interface ReturnLossHistoryTableProps {
	data: GetReturnLossHistoryResponseData[]
	total: number
	isLoading?: boolean
}

export default function ReturnLossHistoryTable({
	data,
	total,
	isLoading,
}: ReturnLossHistoryTableProps) {
	const [greaterThanZero, setGreaterThanZero] = useQueryState(
		'greaterThanZero',
		parseAsBoolean.withOptions({ shallow: false }).withDefault(true),
	)

	return (
		<div className="space-y-4">
			<div className="flex flex-wrap items-center gap-4">
				<DataTableSearch placeHolder="ค้นหาเบอร์โทรศัพท์" />
				<DateRangePicker />
				<DateRangeButtons />
				<div className="flex items-center gap-2 rounded-lg border px-3 py-2">
					<Switch
						id="greaterThanZero"
						checked={greaterThanZero}
						onCheckedChange={setGreaterThanZero}
					/>
					<Label htmlFor="greaterThanZero" className="cursor-pointer">
						ยอดคืนยอดเสียมากกว่า 0
					</Label>
				</div>
				<DataTableResetFilter />
			</div>
			<DataTablePaginate
				columns={columns}
				data={data}
				totalItems={total}
				isLoading={isLoading}
			/>
		</div>
	)
}
